import Vue from 'vue'
import axios from '../../axios'
export var marking = {
  state: {
    scoringTasks: [],
    selectedAssessment: {},
    selectedBasemap: 'https://azmaps.xmap.cloud/epoch18/{z}/{x}/{y}.png',
    selectedResultID: '',
    selectedParticipantName: '',
    searchValue: '',
    answerData: {
      candidate: {},
      assessor: {}
    },

  },
  mutations: {
    SET_BASEMAP (state, layer){
      Vue.set(state, 'selectedBasemap', layer)
    },
    SELECT_PARTICIPANT (state, payload){
      Vue.set(state, 'selectedParticipantName', payload);
    },
    SELECT_RESULT (state, payload){
      Vue.set(state, 'selectedResultID', payload);
    },
    SET_MARK_SEARCH_VALUE (state, payload){
      state.searchValue = payload;
    },
    SET_SCORING_TASKS (state, payload){
      state.scoringTasks = payload;
    },
    SET_ANSWER_DATA (state, payload){
      console.log("SET ANSWER DATA")
      console.dir(payload)
      state.answerData = payload;
    },
    SET_SELECTED_ASSESSMENT (state, payload){
      state.selectedAssessment = payload;
    }
  },
  actions: {
    RESET_RESULT_AND_PARTICIPANT ({commit}){
      commit('SELECT_PARTICIPANT', '');
      commit('SELECT_RESULT', '');
    },
    MARK_FETCH_SCORING_TASKS ({commit}){
      console.log("GET ALL SCORE TASKS")
      return new Promise((resolve, reject) => {
        axios.get('/qm/scoringtasks', {
          params: {
            status: 0
          }
        }).then((response) => {
          console.dir(response);
          commit('SET_SCORING_TASKS', response.data.value);
          resolve();
        })
      })
    },
    MARK_FETCH_SCORING_TASKS_IN_RESULT ({commit, dispatch}, payload){
      dispatch('RESET_RESULT_AND_PARTICIPANT');
      console.log("GET RESULT SCORE TASKS")
      return new Promise((resolve, reject) => {
        axios.get('/qm/scoringtasks_result', {
          params: {
            resultid: payload
          }
        }).then((response) => {
          commit('SET_SCORING_TASKS', response.data.value);
          resolve();
        })
      })
    },
    MARK_FETCH_ANSWER_DATA ({commit}, payload){

      var getCandidateData = function(){
        return axios.get('/qm/getanswermedia', {
          params: {
            url: payload.candidateDataURL
          }
        })
      };

      var getAssessorData = function() {
        return axios.get('/getquestion', {
          params: {
            qid: payload.assessorQuestionID //payload.assessorQuestionID % 100000000
          }
        })
      };

      return new Promise((resolve, reject) => {
        //get the answer supplied by the candidate
        console.dir(payload)
        Promise.all([
          axios.get('/qm/getanswermedia', {
            params: {
              url: payload.candidateDataURL
            }
          }),
          axios.get('/getlinkedquestion', {
            params: {
              linked_id: payload.assessorQuestionID % 100000000
            }
          })
        ]).then((vals) => {
          var obj = {
            candidate: vals[0].data.replace(/\\/g, ""),
            assessor: vals[1].data
          };
          commit('SET_ANSWER_DATA', obj);
          resolve();
        }).catch(err => {
          reject(err)
        })})
    }
  },
  getters: {
    GET_SELECTED_RESULT_AND_PARTICIPANT (state) {
      return {
        result: state.selectedResultID,
        participant: state.selectedParticipantName
      }
    },
    GET_MARK_SEARCH_VALUE (state){
      return state.searchValue;
    },
    GET_ASSESSMENTS (state) {
      var assessments = {};

      state.scoringTasks.forEach((task) => {
        if (!state.searchValue || (task.Result.ID + "_" + task.Result.ParticipantName.toLowerCase()).indexOf(state.searchValue.toLowerCase()) > -1){
          assessments[task.Result.ID + "_" + task.Result.ParticipantName] = {... assessments[task.Result.ID + "_" + task.Result.ParticipantName], [task.Question.ID]: task.Answer}
        }
      });

      return assessments
    },
    GET_SELECTED_ASSESSMENT (state) {
      return state.selectedAssessment
    },
    GET_ANSWER_DATA (state) {
      return state.answerData;
    },
    GET_SELECTED_BASEMAP (state) {
      return state.selectedBasemap
    }
  }
};


